<mat-accordion>
    <mat-expansion-panel [expanded]="true" [disabled]="disable">
        <mat-expansion-panel-header>
            @if (model().meta.title) {
            <mat-panel-title>
                @if (model().meta.editable) {
                <input matInput [formControl]="titleControl" (focus)="onFocus()" (change)="onChange($event)">
                }
                @if (!model().meta.editable) {
                <span>{{model().meta.title}}</span>
                }
            </mat-panel-title>
            }
            @if (model().meta.description) {
            <mat-panel-description>{{model().meta.description}}</mat-panel-description>
            }
        </mat-expansion-panel-header>
        <ng-container [dynamic]="model().child"></ng-container>
    </mat-expansion-panel>
</mat-accordion>
